import { render } from "./GroupTab.vue?vue&type=template&id=28e97866&ts=true"
import script from "./GroupTab.vue?vue&type=script&lang=ts"
export * from "./GroupTab.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__